import { render } from "./NavigationMenu.vue?vue&type=template&id=460e0e4d"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__